import React from 'react';
import { AppProviderMicroFrontend } from '@allie/mfe';
import { setupIonicReact } from '@ionic/react';
import { env } from '@env';

// SPRINT 79

setupIonicReact();

/**
 * Simple shell application that redirects all routing and logic to app-provider MFE
 * This container is now only responsible for:
 * 1. Ionic setup
 * 2. Routing capture and redirection to app-provider
 * 3. Minimal configuration
 * 4. iOS keyboard fix
 */
const App: React.FC = () => {
  // Extract basePath from current URL to pass to app-provider
  const currentPath = window.location.pathname;
  const basePath = currentPath.split('/')[1] || '';

  // Wordings de error en español (no hay acceso a traducciones aquí)
  const errorMessage = {
    TITLE: 'No pudimos cargar la información',
    DESCRIPTION_LINE_1: 'Recarga la página y vuelve a intentarlo.',
    DESCRIPTION_LINE_2: 'Si el problema persiste, contacta a soporte.',
    BUTTON_TEXT: 'Recargar página',
  };

  return (
    <AppProviderMicroFrontend
      entryPointUrl={env.REACT_APP_APP_PROVIDER_ENTRYPOINT}
      basePath={basePath}
      errorMessage={errorMessage}
    />
  );
};

export default App;
